/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import styled from "styled-components";
import { Text, theme, Table, FlexContainer } from "@nordcloud/gnui";
import { Column } from "~/types";

const ItemLabel = styled(Text)<{ disabled: boolean }>`
  user-select: none;
  cursor: ${({ disabled }) => (disabled ? "no-drop" : "pointer")};
`;

const ItemValue = styled(ItemLabel)`
  word-break: break-all;
  text-align: left;
`;

type Props = {
  column: Column;
  showValueInOptions?: boolean;
  isDisabled: boolean;
};

export function SidebarItemTextColumn({
  column,
  showValueInOptions,
  isDisabled,
}: Props) {
  const label = column.data[0] === "undefined" ? "" : column.data[0];

  return (
    <Table.td
      css={{ padding: `${theme.spacing.spacing02}`, wordBreak: "break-all" }}
    >
      <FlexContainer direction="column" alignItems="flex-start">
        <ItemLabel id={label} tag="span" disabled={isDisabled}>
          {label}
        </ItemLabel>
        <When condition={showValueInOptions}>
          <ItemValue
            size="sm"
            tag="span"
            color={theme.color.text.text02}
            disabled={isDisabled}
          >
            {column.data[1]}
          </ItemValue>
        </When>
      </FlexContainer>
    </Table.td>
  );
}
